import React, { useState, useEffect } from 'react';
import "./Faq.scss";
import Accordion from 'react-bootstrap/Accordion';
import { GetFaqService } from '../../../services/CmsService';
import { AccordionPlaceholder } from '../../../components/skeleton-placeholder';
import { NoDataFound } from '../../../components/no-data-found';

const Faq = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [faqData, setFaqData] = useState([]);

    const getFaqApi = async () => {
        setIsLoading(true);
        await GetFaqService(null, async (res) => {
            setIsLoading(false);
            if (res.status === 200) {
                setFaqData(res.data.data);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    };

    useEffect(() => {
        getFaqApi();
    }, []);
    
    return (
        <>
            <section className="inner-title-block inner-mrt-80">
                <div className="container-lg text-center">
                    <h1>FAQ</h1>
                </div>
            </section>
            <section className="faq-wrapper padd-top-70 padd-bottom-70">
                <div className="container-lg">
                    {isLoading ?
                        <AccordionPlaceholder />
                        :
                        faqData?.length > 0 ?
                            <Accordion>
                                {faqData?.map((data, index) => {
                                    return (
                                        <Accordion.Item key={data._id} eventKey={index}>
                                            <Accordion.Header>{data.question} </Accordion.Header>
                                            <Accordion.Body>
                                                {data.answer}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )
                                })}
                            </Accordion>
                            :
                            <NoDataFound text="No Result Found" />
                    }
                </div>
            </section>
        </>
    );
}

export default Faq;